import {Controller} from "@hotwired/stimulus"

const PASSWORD_KEY = "crypto_unlock_key"
const PUBLIC_KEY_COOKIE = "rsa_public_key"
const PRIVATE_KEY_COOKIE = "rsa_private_key"

export default class CryptoInitController extends Controller {
    connect(): void {
        document.addEventListener("turbo:load", this.setCryptokeys)
        // Also run immediately in case the page was loaded without Turbo
        this.setCryptokeys().then()
    }

    disconnect(): void {
        document.removeEventListener("turbo:load", this.setCryptokeys)
    }

    private setCryptokeys = async (): Promise<void> => {
        const password = sessionStorage.getItem(PASSWORD_KEY)
        if (!password) return

        try {
            const locale = document.documentElement.lang || "de"
            const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""

            const response = await fetch(`/${locale}/api/crypto_keys`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken
                },
                body: JSON.stringify({password})
            })

            if (!response.ok) {
                console.error("[CryptoInit] API call failed:", response.status)
                return
            }

            const data = await response.json() as { public_key: string; private_key: string }

            // Store keys as session cookies (no expiry = session cookie)
            // Keys are Base64-encoded DER – no URL-encoding needed
            document.cookie = `${PUBLIC_KEY_COOKIE}=${data.public_key}; path=/; SameSite=Strict`
            document.cookie = `${PRIVATE_KEY_COOKIE}=${data.private_key}; path=/; SameSite=Strict`

            // Only remove the password after keys have been successfully stored
            sessionStorage.removeItem(PASSWORD_KEY)

            // Notify other controllers that crypto keys are ready
            document.dispatchEvent(new CustomEvent("crypto:keys-ready"))
        } catch (error) {
            console.error("[CryptoInit] Unexpected error during key retrieval:", error)
        }
    }
}
